// @ts-nocheck
import { FieldsDictionary } from "@store/Framework/Features/FieldDefinitionBuilder/FieldDefinitionBuilderTypes";

const imageFieldDictionary: FieldsDictionary = {
    positionX: {
        name: "positionX",
        defaultValue: 0,
        editorTemplate: "IntegerField",
        tooltip: "Position on the X axis",
        fieldType: "General",
        min: -500,
    },
    positionY: {
        name: "positionY",
        defaultValue: 0,
        editorTemplate: "IntegerField",
        tooltip: "Position on the Y axis",
        fieldType: "General",
        min: -500,
    },
};

export default imageFieldDictionary;
